"use client";
import React, { useEffect, useState } from "react";
import { Input, Select, Pagination, Spin, Empty } from "antd";
import { IoSearchOutline } from "react-icons/io5";
import { ArrowLeft, ArrowRight } from "lucide-react";
import SectionTitle from "@/components/common/section-title/SectionTitle";
import BranchCard from "./components/BranchCard";
import { PiMagnifyingGlassBold } from "react-icons/pi";
import CommonService from "@/services/api/CommonService";
import CustomPagination from "@/components/common/Pagination/CustomPagination";
import { usePublicFetch } from "@/hook/usePublicFetch";

const { Option } = Select;

export default function BranchesPage() {
  const [search, setSearch] = useState("");
  const [districtId, setDistrictId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(9);

  const { data: districts = [], isLoading: districtsLoading } = usePublicFetch(
    "districts",
    () => CommonService.getAllDistricts(),
    {},
    {
      staleTime: 60 * 60 * 1000,
      cacheTime: 24 * 60 * 60 * 1000,
    }
  );

  const {
    data: branchesResponse,
    isLoading: branchesLoading,
    isFetching: isFetchingBranches,
  } = usePublicFetch(
    ["branches", search, districtId, currentPage, pageSize],
    () =>
      CommonService.getAllBranch({
        page: currentPage,
        per_page: pageSize,
        search,
        district_id: districtId,
      }),
    {},
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 15 * 60 * 1000,
      keepPreviousData: true,
    }
  );

  const branches = branchesResponse?.data || [];
  const totalItems = branchesResponse?.total || 0;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (currentPage === 1) {
      } else {
        setCurrentPage(1);
      }
    }, 800);

    return () => clearTimeout(timeoutId);
  }, [search, districtId]);

  const handleSearch = () => {
    setCurrentPage(1);
  };

  const loading = districtsLoading || (branchesLoading && !branchesResponse);

  return (
    <section className="branches_section bg-animation section_padding">
      <div className="container">
        <div className="branch-top-card">
          <SectionTitle
            iconSrc={"/images/admission-icon/location-icon.png"}
            title="দেশ ব্যাপী ফোকাসের শাখাসমূহ"
            description={
              "ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।"
            }
          />

          {/* Search area */}
          <div className="branch-search-area">
            <div className="search-content">
              <div className="branch-name">
                <Input
                  placeholder="শাখার নাম দিয়ে খুজুন"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <div className="branch-location">
                <Select
                  allowClear
                  showSearch
                  value={districtId}
                  onChange={(value) => setDistrictId(value)}
                  placeholder="লোকেশন বাছাই করে খুজুন"
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                >
                  {districts.map((district) => (
                    <Option key={district.id} value={district.id}>
                      {district.name}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="search">
                <button className="search_btn" onClick={handleSearch}>
                  <PiMagnifyingGlassBold />
                </button>
              </div>
            </div>
          </div>
        </div>

        {branches.length > 0 ? (
          <div className="branches-list">
            {branches
              .filter((branch) => branch.name && branch.phone)
              .map((branch, index) => (
                <BranchCard
                  key={index}
                  title={branch.name}
                  number1={branch.phone}
                  number2={branch.phone2}
                  slug={branch.slug}
                  address={branch.address}
                />
              ))}
          </div>
        ) : (
          <div className="flex items-center justify-center py-10 text-gray-500  w-full">
            <Empty description="কোনো শাখা শাখাসমূহ পাওয়া যায়নি।" />
          </div>
        )}

        {/* Pagination */}
        <CustomPagination
          currentPage={currentPage}
          pageSize={pageSize}
          totalItems={totalItems}
          onPageChange={setCurrentPage}
        />
      </div>
    </section>
  );
}
